import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

import { LpToCfEntityGrouping, AssignmentStrategy } from '../types';
import { AssignmentSelectStrategyTable } from './AssignmentSelectStrategyContainer';

export const AssignmentStrategiesForImplementation = ({
  lpToCfEntityGrouping,
  assignmentStrategies,
  refetchStrategies,
}: {
  lpToCfEntityGrouping: LpToCfEntityGrouping;
  assignmentStrategies: AssignmentStrategy[];
  refetchStrategies: () => void;
}) => {
  const loanProductsTitle = lpToCfEntityGrouping.loanProducts
    .map((loanProduct) => loanProduct.name)
    .join(', ');

  return (
    <Box>
      <Heading fontSize="24px" mb="32px">
        {loanProductsTitle}
      </Heading>
      <AssignmentSelectStrategyTable
        isEditable
        assignmentStrategies={assignmentStrategies}
        refetchStrategies={refetchStrategies}
        implementationId={lpToCfEntityGrouping.implementationId}
      />
    </Box>
  );
};
